import React from 'react';
import { fComp } from '../../utils/React.js';
import { TogglePresentation } from '../Toggle/TogglePresentation.js';
import { hostClass } from './Radio.styles.js';

var defaultProps = {};
var RadioPresentation = fComp(function (props) {
  return /*#__PURE__*/React.createElement(TogglePresentation, Object.assign({}, props, {
    hostClass: hostClass,
    type: "radio"
  }));
}, defaultProps);
RadioPresentation.displayName = "RadioPresentation";

export { RadioPresentation, defaultProps };
